export class AccessTokenProvider {
  private readonly _routesThatNeedBuyerToken: Set<string> = new Set([]);
  private readonly _pagesThatNeedTheBuyerToken: Set<string> = new Set([]);

  public getAccessToken(
    routeUrl: string,
    pageUrl: string,
    accessToken: string,
  ): string {
    // TODO: Add the logic to get the service buyer token and multi buyer company token when needed.
    const typedAuth = {
      isLoggedInAsServiceBuyer: false,
      isSelectedMultiBuyerCompany: false,
      serviceBuyer: { token: '' },
      selectedMultiBuyerCompany: { token: '' },
    };

    const isOperatorExclusiveRequest =
      this._routesThatNeedBuyerToken.has(routeUrl);
    const isServiceBuyerTokenNeeded =
      this._pagesThatNeedTheBuyerToken.has(pageUrl);

    if (!isOperatorExclusiveRequest && isServiceBuyerTokenNeeded) {
      if (typedAuth.isLoggedInAsServiceBuyer) {
        accessToken = typedAuth.serviceBuyer?.token ?? accessToken;
      } else if (typedAuth.isSelectedMultiBuyerCompany) {
        accessToken = typedAuth.selectedMultiBuyerCompany?.token ?? accessToken;
      }
    }
    return accessToken;
  }
}
